<template>
  <div class="users-container">
    <el-card class="full-height-card">
      <div slot="header" class="header-container">
        <span>用户管理</span>
      </div>
      
      <!-- 搜索表单 -->
      <el-form :inline="true" :model="searchForm" class="search-form">
        <el-form-item>
          <el-input v-model="searchForm.username" placeholder="用户名" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="searchForm.phone" placeholder="手机号" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="searchForm.email" placeholder="邮箱" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch">搜索</el-button>
          <el-button @click="resetSearch">重置</el-button>
        </el-form-item>
      </el-form>
      
      <!-- 移动端卡片列表 -->
      <div class="mobile-cards" v-if="isMobile">
        <el-card v-for="user in userList" :key="user.id" class="mobile-card">
          <div class="card-header">
            <span class="username">{{ user.username }}</span>
            <el-tag :type="user.status === 1 ? 'success' : 'danger'" size="small">
              {{ user.status === 1 ? '正常' : '禁用' }}
            </el-tag>
          </div>
          <div class="card-content">
            <div class="info-item">
              <span class="label">姓名：</span>
              <span>{{ user.name || '未设置' }}</span>
            </div>
            <div class="info-item">
              <span class="label">手机号：</span>
              <span>{{ user.phone || '未设置' }}</span>
            </div>
            <div class="info-item">
              <span class="label">邮箱：</span>
              <span>{{ user.email || '未设置' }}</span>
            </div>
            <div class="info-item">
              <span class="label">总额：</span>
              <span>{{ user.totalBalance || '0.00' }}</span>
            </div>
            <div class="info-item">
              <span class="label">可用余额：</span>
              <span>{{ user.balance || '0.00' }}</span>
            </div>
            <div class="info-item">
              <span class="label">会员等级：</span>
              <span>{{ user.vipLevel || '非VIP用户' }}</span>
            </div>
            <div class="info-item">
              <span class="label">注册时间：</span>
              <span>{{ formatDate(user.createTime) }}</span>
            </div>
          </div>
          <div class="card-footer">
            <el-button-group>
              <el-button size="mini" @click="handleEdit(user)">编辑</el-button>
              <el-button size="mini" type="danger" @click="handleDelete(user)">删除</el-button>
              <el-button size="mini" type="success" @click="handleRecharge(user)">操作账户</el-button>
              <el-button size="mini" type="primary" @click="handleTransfer(user)">转账</el-button>
            </el-button-group>
            <el-dropdown size="mini" @command="handleCommand($event, user)" trigger="click">
              <el-button size="mini" type="primary">
                更多<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="resetLoginPwd">重置登录密码</el-dropdown-item>
                <el-dropdown-item command="resetPayPwd">重置支付密码</el-dropdown-item>
                <el-dropdown-item command="viewTransactions">查看资金往来</el-dropdown-item>
                <el-dropdown-item command="setVip">设置VIP等级</el-dropdown-item>
                <el-dropdown-item command="freeWallet">冻结钱包</el-dropdown-item>
                <el-dropdown-item command="unfreeWallet">解除冻结钱包</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </el-card>
      </div>
      
      <!-- PC端表格 -->
      <el-table
        v-else
        v-loading="loading"
        :data="userList"
        border
        style="width: 100%">
        <el-table-column
          prop="id"
          label="ID"
          width="80">
        </el-table-column>
        <el-table-column
          prop="username"
          label="用户名"
          width="120">
        </el-table-column>
        <el-table-column
          prop="name"
          label="姓名"
          width="120">
          <template slot-scope="scope">
            <el-input 
              v-if="scope.row.isEdit" 
              v-model="scope.row.name" 
              size="small">
            </el-input>
            <span v-else>{{ scope.row.name }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="phone"
          label="手机号"
          width="120">
          <template slot-scope="scope">
            {{ scope.row.phone || '未设置' }}
          </template>
        </el-table-column>
        <el-table-column
          label="总额"
          width="120">
          <template slot-scope="scope">
            <div class="balance-cell">
              <span>{{ scope.row.totalBalance || '0.00' }}</span>
              <el-button type="text" size="mini" @click.stop="handleRecharge(scope.row)">操作帐户</el-button>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="可用余额"
          width="120">
          <template slot-scope="scope">
            <div class="balance-cell">
              <span>{{ scope.row.balance || '0.00' }}</span>
              <el-button type="text" size="mini" @click.stop="handleRecharge(scope.row)">操作帐户</el-button>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="会员等级"
          width="120">
          <template slot-scope="scope">
            {{ scope.row.vipLevel || '非VIP用户' }}
          </template>
        </el-table-column>
        <el-table-column
          prop="email"
          label="邮箱"
          width="180">
          <template slot-scope="scope">
            {{ scope.row.email || '未设置' }}
          </template>
        </el-table-column>
        <el-table-column
          prop="type"
          label="类型"
          width="100">
        </el-table-column>
        <el-table-column
          prop="status"
          label="状态"
          width="100">
          <template slot-scope="scope">
            <el-select 
              v-if="scope.row.isEdit" 
              v-model="scope.row.status" 
              size="small" 
              style="width: 100%">
              <el-option label="正常" :value="1"></el-option>
              <el-option label="禁用" :value="0"></el-option>
            </el-select>
            <el-tag v-else :type="scope.row.status === 1 ? 'success' : 'danger'">
              {{ scope.row.status === 1 ? '正常' : '禁用' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="创建时间"
          width="180">
          <template slot-scope="scope">
            {{ formatDate(scope.row.createTime) }}
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          width="180">
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.isEdit"
              size="mini"
              type="success"
              @click="saveEdit(scope.row)"
              :loading="scope.row.saveLoading">保存</el-button>
            <el-button
              v-else
              size="mini"
              @click="handleEdit(scope.row)">编辑</el-button>
            <el-button
              size="mini"
              type="danger"
              :disabled="scope.row.isEdit"
              @click="handleDelete(scope.row)">删除</el-button>
            <el-button
              size="mini"
              type="success"
              :disabled="scope.row.isEdit"
              @click="handleTransfer(scope.row)">转账</el-button>
            <el-dropdown size="mini" @command="handleCommand($event, scope.row)" trigger="click">
              <el-button size="mini" type="primary">
                更多<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="resetLoginPwd">重置登录密码</el-dropdown-item>
                <el-dropdown-item command="resetPayPwd">重置支付密码</el-dropdown-item>
                <el-dropdown-item command="viewTransactions">查看资金往来</el-dropdown-item>
                <el-dropdown-item command="setVip">设置VIP等级</el-dropdown-item>
                <el-dropdown-item command="freeWallet">冻结钱包</el-dropdown-item>
                <el-dropdown-item command="unfreeWallet">解除冻结钱包</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
      
      <!-- 分页 -->
      <div class="pagination-container">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.pageNum"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pagination.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total">
        </el-pagination>
      </div>
    </el-card>

    <!-- 充值对话框 -->
    <el-dialog title="用户操作" :visible.sync="rechargeDialogVisible" width="400px">
      <el-form :model="rechargeForm" :rules="rechargeRules" ref="rechargeForm" label-width="80px">
        <el-form-item label="用户名">
          <span>{{ rechargeForm.username }}</span>
        </el-form-item>
        <el-form-item label="用户ID">
          <span>{{ rechargeForm.userId }}</span>
        </el-form-item>
        
        <el-form-item label="操作选择" prop="type">
          <el-select v-model="rechargeForm.type" placeholder="请选择(充值、扣款、冻结)" style="width: 100%">
            <el-option label="充值" value="RECHARGE"></el-option>
            <el-option label="扣款" value="DEDUCT"></el-option>
            <el-option label="冻结" value="FREEZE"></el-option>
            <el-option label="解除冻结" value="UNFREEZE"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="充值金额" prop="amount">
          <el-input-number v-model="rechargeForm.amount" :min="0.01" :precision="2" :step="100" style="width: 100%"></el-input-number>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="rechargeDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitRecharge" :loading="rechargeLoading">确认充值</el-button>
      </div>
    </el-dialog>

    <!-- 重置登录密码对话框 -->
    <el-dialog title="重置登录密码" :visible.sync="resetLoginPwdDialogVisible" width="400px">
      <el-form :model="resetPwdForm" :rules="resetPwdRules" ref="resetLoginPwdForm" label-width="80px">
        <el-form-item label="用户名">
          <span>{{ resetPwdForm.username }}</span>
        </el-form-item>
        <el-form-item label="用户ID">
          <span>{{ resetPwdForm.userId }}</span>
        </el-form-item>
        <el-form-item label="新密码" prop="password">
          <el-input v-model="resetPwdForm.password" type="password" show-password></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="confirmPassword">
          <el-input v-model="resetPwdForm.confirmPassword" type="password" show-password></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="resetLoginPwdDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitResetLoginPwd" :loading="resetPwdLoading">确认重置</el-button>
      </div>
    </el-dialog>

    <!-- 重置支付密码对话框 -->
    <el-dialog title="重置支付密码" :visible.sync="resetPayPwdDialogVisible" width="400px">
      <el-form :model="resetPwdForm" :rules="resetPwdRules" ref="resetPayPwdForm" label-width="80px">
        <el-form-item label="用户名">
          <span>{{ resetPwdForm.username }}</span>
        </el-form-item>
        <el-form-item label="用户ID">
          <span>{{ resetPwdForm.userId }}</span>
        </el-form-item>
        <el-form-item label="新密码" prop="password">
          <el-input v-model="resetPwdForm.password" type="password" show-password></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="confirmPassword">
          <el-input v-model="resetPwdForm.confirmPassword" type="password" show-password></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="resetPayPwdDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitResetPayPwd" :loading="resetPwdLoading">确认重置</el-button>
      </div>
    </el-dialog>

    <!-- 资金往来记录对话框 -->
    <el-dialog title="资金往来记录" :visible.sync="transactionsDialogVisible" width="900px" :fullscreen="false">
      <div class="transactions-container">
        <div class="transactions-header">
          <span>用户: {{ currentUser.username }} (ID: {{ currentUser.id }})</span>
          <el-date-picker
            v-model="transactionDateRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            @change="handleDateRangeChange">
          </el-date-picker>
        </div>
        
        <el-tabs v-model="activeTransactionTab">
          <el-tab-pane label="质押订单" name="pledgeOrders">
            <el-table :data="transactions.pledgeOrders" border v-loading="transactionsLoading" height="400">
              <el-table-column prop="id" label="ID" width="60"></el-table-column>
              <el-table-column prop="name" label="名称" width="100"></el-table-column>
              <el-table-column prop="pledgeAmount" label="质押金额" width="120">
                <template slot-scope="scope">{{ scope.row.pledgeAmount.toFixed(2) }}</template>
              </el-table-column>
              <el-table-column prop="expectedIncome" label="预期收益" width="120">
                <template slot-scope="scope">{{ scope.row.expectedIncome.toFixed(2) }}</template>
              </el-table-column>
              <el-table-column prop="status" label="状态" width="100">
                <template slot-scope="scope">
                  <el-tag :type="getPledgeStatusType(scope.row.status)">{{ getPledgeStatusText(scope.row.status) }}</el-tag>
                </template>
              </el-table-column>
              <el-table-column prop="createTime" label="创建时间" width="180">
                <template slot-scope="scope">{{ formatDate(scope.row.createTime) }}</template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
          
          <el-tab-pane label="收款记录" name="collections">
            <el-table :data="transactions.collections" border v-loading="transactionsLoading" height="400">
              <el-table-column prop="id" label="ID" width="60"></el-table-column>
              <el-table-column prop="fromUserId" label="付款人ID" width="100"></el-table-column>
              <el-table-column prop="amount" label="金额" width="120">
                <template slot-scope="scope">{{ scope.row.amount.toFixed(2) }}</template>
              </el-table-column>
              <el-table-column prop="toBalance" label="收款后余额" width="120">
                <template slot-scope="scope">{{ scope.row.toBalance.toFixed(2) }}</template>
              </el-table-column>
              <el-table-column prop="status" label="状态" width="100">
                <template slot-scope="scope">
                  <el-tag :type="scope.row.status === 1 ? 'success' : 'danger'">
                    {{ scope.row.status === 1 ? '成功' : '失败' }}
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column prop="createTime" label="创建时间" width="180">
                <template slot-scope="scope">{{ formatDate(scope.row.createTime) }}</template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
          
          <el-tab-pane label="付款记录" name="payments">
            <el-table :data="transactions.payments" border v-loading="transactionsLoading" height="400">
              <el-table-column prop="id" label="ID" width="60"></el-table-column>
              <el-table-column prop="toUserId" label="收款人ID" width="100"></el-table-column>
              <el-table-column prop="amount" label="金额" width="120">
                <template slot-scope="scope">{{ scope.row.amount.toFixed(2) }}</template>
              </el-table-column>
              <el-table-column prop="fromBalance" label="付款后余额" width="120">
                <template slot-scope="scope">{{ scope.row.fromBalance.toFixed(2) }}</template>
              </el-table-column>
              <el-table-column prop="status" label="状态" width="100">
                <template slot-scope="scope">
                  <el-tag :type="scope.row.status === 1 ? 'success' : 'danger'">
                    {{ scope.row.status === 1 ? '成功' : '失败' }}
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column prop="createTime" label="创建时间" width="180">
                <template slot-scope="scope">{{ formatDate(scope.row.createTime) }}</template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
          
          <el-tab-pane label="提现记录" name="withdraws">
            <el-table :data="transactions.withdraws" border v-loading="transactionsLoading" height="400">
              <el-table-column prop="id" label="ID" width="60"></el-table-column>
              <el-table-column prop="amount" label="提现金额" width="120">
                <template slot-scope="scope">{{ scope.row.amount.toFixed(2) }}</template>
              </el-table-column>
              <el-table-column prop="fromBalance" label="提现前余额" width="120">
                <template slot-scope="scope">{{ scope.row.fromBalance.toFixed(2) }}</template>
              </el-table-column>
              <el-table-column prop="status" label="状态" width="100">
                <template slot-scope="scope">
                  <el-tag :type="getWithdrawStatusType(scope.row.status)">
                    {{ getWithdrawStatusText(scope.row.status) }}
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column prop="remark" label="备注" width="150"></el-table-column>
              <el-table-column prop="createTime" label="创建时间" width="180">
                <template slot-scope="scope">{{ formatDate(scope.row.createTime) }}</template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
          
          <el-tab-pane label="充值记录" name="recharges">
            <el-table :data="transactions.recharges" border v-loading="transactionsLoading" height="400">
              <el-table-column prop="id" label="ID" width="60"></el-table-column>
              <el-table-column prop="payOrderId" label="支付订单ID" width="220"></el-table-column>
              <el-table-column prop="amount" label="充值金额" width="120">
                <template slot-scope="scope">{{ scope.row.amount.toFixed(4) }}</template>
              </el-table-column>
              <el-table-column prop="payType" label="支付类型" width="120"></el-table-column>
              <el-table-column prop="status" label="状态" width="100">
                <template slot-scope="scope">
                  <el-tag :type="getRechargeStatusType(scope.row.status)">
                    {{ getRechargeStatusText(scope.row.status) }}
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column prop="createTime" label="创建时间" width="180">
                <template slot-scope="scope">{{ formatDate(scope.row.createTime) }}</template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-dialog>

    <!-- 设置VIP等级对话框 -->
    <el-dialog title="设置VIP等级" :visible.sync="setVipDialogVisible" width="400px">
      <el-form :model="vipForm" :rules="vipRules" ref="vipForm" label-width="80px">
        <el-form-item label="用户名">
          <span>{{ vipForm.username }}</span>
        </el-form-item>
        <el-form-item label="用户ID">
          <span>{{ vipForm.userId }}</span>
        </el-form-item>
        <el-form-item label="当前等级">
          <span>{{ vipForm.currentVipLevel || '非VIP用户' }}</span>
        </el-form-item>
        <el-form-item label="VIP等级" prop="vipId">
          <el-select v-model="vipForm.vipId" placeholder="请选择VIP等级" style="width: 100%">
            <el-option
              v-for="item in vipLevels"
              :key="item.id"
              :label="item.name"
              :value="item.level">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="setVipDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitSetVip" :loading="setVipLoading">确认设置</el-button>
      </div>
    </el-dialog>

    <!-- 转账对话框 -->
    <el-dialog title="用户转账" :visible.sync="transferDialogVisible" width="500px">
      <el-form :model="transferForm" :rules="transferRules" ref="transferForm" label-width="100px">
        <el-form-item label="转账方">
          <el-input v-model="transferForm.fromUsername" placeholder="请输入转账方用户名" @blur="handleFromUserBlur">
            <template slot="append">
              <el-button @click="handleFromUserBlur">查询</el-button>
            </template>
          </el-input>
          <div v-if="transferForm.fromUserInfo" class="user-info">
            <p>用户名：{{ transferForm.fromUserInfo.username }}</p>
            <p>姓名：{{ transferForm.fromUserInfo.name }}</p>
            <p>余额：{{ transferForm.fromUserInfo.balance }}</p>
          </div>
        </el-form-item>
        <el-form-item label="收款方">
          <el-input v-model="transferForm.toUsername" placeholder="请输入收款方用户名" @blur="handleToUserBlur">
            <template slot="append">
              <el-button @click="handleToUserBlur">查询</el-button>
            </template>
          </el-input>
          <div v-if="transferForm.toUserInfo" class="user-info">
            <p>用户名：{{ transferForm.toUserInfo.username }}</p>
            <p>姓名：{{ transferForm.toUserInfo.name }}</p>
            <p>余额：{{ transferForm.toUserInfo.balance }}</p>
          </div>
        </el-form-item>
        <el-form-item label="转账金额" prop="amount">
          <el-input-number v-model="transferForm.amount" :min="0.01" :precision="2" :step="100" style="width: 100%"></el-input-number>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="transferDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitTransfer" :loading="transferLoading">确认转账</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'Users',
  data() {
    return {
      loading: false,
      userList: [],
      searchForm: {
        username: '',
        phone: '',
        email: ''
      },
      pagination: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      rechargeDialogVisible: false,
      rechargeForm: {
        userId: '',
        username: '',
        type: 'RECHARGE',
        amount: 100
      },
      rechargeRules: {
        amount: [
          { required: true, message: '请输入充值金额', trigger: 'blur' },
          { type: 'number', min: 0.01, message: '充值金额必须大于0', trigger: 'blur' }
        ],
        type: [
          { required: true, message: '请选择操作类型', trigger: 'blur' }
        ]
      },
      rechargeLoading: false,
      resetLoginPwdDialogVisible: false,
      resetPayPwdDialogVisible: false,
      resetPwdForm: {
        userId: '',
        username: '',
        password: '',
        confirmPassword: ''
      },
      resetPwdRules: {
        password: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { min: 6, message: '密码长度不能少于6个字符', trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, message: '请确认新密码', trigger: 'blur' },
          { 
            validator: (rule, value, callback) => {
              if (value !== this.resetPwdForm.password) {
                callback(new Error('两次输入的密码不一致'));
              } else {
                callback();
              }
            }, 
            trigger: 'blur' 
          }
        ]
      },
      resetPwdLoading: false,
      transactionsDialogVisible: false,
      transactionsLoading: false,
      currentUser: {},
      activeTransactionTab: 'pledgeOrders',
      transactionDateRange: [],
      transactions: {
        pledgeOrders: [],
        collections: [],
        payments: [],
        withdraws: [],
        recharges: []
      },
      // VIP等级设置
      setVipDialogVisible: false,
      vipForm: {
        userId: '',
        username: '',
        currentVipLevel: '',
        vipId: ''
      },
      vipRules: {
        vipId: [
          { required: true, message: '请选择VIP等级', trigger: 'change' }
        ]
      },
      setVipLoading: false,
      vipLevels: [], // VIP等级列表
      transferDialogVisible: false,
      transferForm: {
        fromUsername: '',
        toUsername: '',
        amount: 100,
        fromUserInfo: null,
        toUserInfo: null
      },
      transferRules: {
        amount: [
          { required: true, message: '请输入转账金额', trigger: 'blur' },
          { type: 'number', min: 0.01, message: '转账金额必须大于0', trigger: 'blur' }
        ]
      },
      transferLoading: false,
      isMobile: false
    }
  },
  methods: {
    // 获取用户列表
    fetchUserList() {
      this.loading = true
      
      const params = {
        pageNum: this.pagination.pageNum,
        pageSize: this.pagination.pageSize,
        username: this.searchForm.username || undefined,
        phone: this.searchForm.phone || undefined,
        email: this.searchForm.email || undefined
      }
      
      axios.get('/user/page', { params })
        .then(response => {
          this.loading = false
          const { data } = response.data
          
          // 为每一行添加编辑状态和原始数据备份
          this.userList = data.data.map(item => ({
            ...item,
            isEdit: false,
            saveLoading: false,
            originalData: { ...item } // 保存原始数据，用于取消编辑
          }))
          this.pagination.total = data.total
          this.pagination.pageNum = data.pageNum
          this.pagination.pageSize = data.pageSize
        })
        .catch(error => {
          this.loading = false
          console.error('获取用户列表失败:', error)
          this.$message.error('获取用户列表失败')
        })
    },
    
    // 搜索
    handleSearch() {
      this.pagination.pageNum = 1
      this.fetchUserList()
    },
    
    // 重置搜索
    resetSearch() {
      this.searchForm = {
        username: '',
        phone: '',
        email: ''
      }
      this.pagination.pageNum = 1
      this.fetchUserList()
    },
    
    // 改变每页显示数量
    handleSizeChange(val) {
      this.pagination.pageSize = val
      this.fetchUserList()
    },
    
    // 改变页码
    handleCurrentChange(val) {
      this.pagination.pageNum = val
      this.fetchUserList()
    },
    
    // 编辑用户
    handleEdit(row) {
      // 先取消其他行的编辑状态
      this.userList.forEach(item => {
        if (item.id !== row.id && item.isEdit) {
          this.cancelEdit(item)
        }
      })
      
      // 设置当前行为编辑状态
      row.isEdit = true
      // 保存原始数据，用于取消编辑
      row.originalData = { ...row }
    },
    
    // 取消编辑
    cancelEdit(row) {
      // 恢复原始数据
      Object.assign(row, row.originalData)
      row.isEdit = false
    },
    
    // 保存编辑
    saveEdit(row) {
      // 验证
      if (!row.name || row.name.trim() === '') {
        this.$message.error('姓名不能为空')
        return
      }
      
      row.saveLoading = true
      
      // 构建请求数据
      const data = {
        id: row.id,
        name: row.name,
        status: row.status
      }
      
      // 发送更新请求
      axios.put('/user/update', data)
        .then(response => {
          row.saveLoading = false
          
          if (response.data.status === 200) {
            this.$message.success('更新成功')
            row.isEdit = false
            // 更新原始数据
            row.originalData = { ...row }
          } else {
            this.$message.error(response.data.message || '更新失败')
          }
        })
        .catch(error => {
          row.saveLoading = false
          const errorMsg = error.response && error.response.data && error.response.data.message
            ? error.response.data.message
            : '网络错误，请稍后重试'
          this.$message.error(errorMsg)
          console.error('更新用户失败:', error)
        })
    },
    
    // 删除用户
    handleDelete(row) {
      this.$confirm(`确认删除用户 ${row.username}?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 发送删除请求
        axios.delete(`/user/delete/${row.id}`)
          .then(response => {
            if (response.data.status === 200) {
              this.$message.success('删除成功')
              this.fetchUserList() // 刷新列表
            } else {
              this.$message.error(response.data.message || '删除失败')
            }
          })
          .catch(error => {
            const errorMsg = error.response && error.response.data && error.response.data.message
              ? error.response.data.message
              : '网络错误，请稍后重试'
            this.$message.error(errorMsg)
            console.error('删除用户失败:', error)
          })
      }).catch(() => {
        // 取消删除
      })
    },
    
    // 格式化日期
    formatDate(dateStr) {
      if (!dateStr) return '未知'
      
      const date = new Date(dateStr)
      return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')} ${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}`
    },
    
    // 处理充值
    handleRecharge(row) {
      this.rechargeForm.userId = row.id
      this.rechargeForm.username = row.username
      this.rechargeForm.amount = 100
      this.rechargeDialogVisible = true
      
      // 在下一个事件循环中重置表单验证
      this.$nextTick(() => {
        if (this.$refs.rechargeForm) {
          this.$refs.rechargeForm.clearValidate()
        }
      })
    },

    // 提交充值
    submitRecharge() {
      this.$refs.rechargeForm.validate(valid => {
        if (valid) {
          this.rechargeLoading = true
          
          // 构建请求数据
          const data = {
            userId: this.rechargeForm.userId,
            amount: this.rechargeForm.amount,
            type: this.rechargeForm.type
          }
          
          // 发送充值请求
          axios.post('/balance/opt/supper', data)
            .then(response => {
              this.rechargeLoading = false
              this.rechargeDialogVisible = false
              this.$message.success('成功')
              this.fetchUserList()
            })
            .catch(error => {
              this.rechargeLoading = false
              this.$message.error('失败')
              console.error('失败:', error)
            })
        } else {
          console.error('表单验证失败')
          this.rechargeLoading = false
        }
      })
    },

    // 处理更多操作
    handleCommand(command, row) {
      switch (command) {
        case 'resetLoginPwd':
          this.handleResetLoginPwd(row)
          break
        case 'resetPayPwd':
          this.handleResetPayPwd(row)
          break
        case 'viewTransactions':
          this.handleViewTransactions(row)
          break
        case 'setVip':
          this.handleSetVip(row)
          break
        case 'freeWallet':
          this.handleFreeWallet(row)
          break
        case 'unfreeWallet':
          this.handleUnFreeWallet(row)
          break
      }
    },

    handleFreeWallet(row) {
      this.$confirm(`确认冻结用户 ${row.username} 的钱包?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 发送删除请求
        axios.delete(`/balance/free/wallet/${row.id}`)
          .then(response => {
            if (response.data.status === 200) {
              this.$message.success('冻结成功')
              this.fetchUserList() // 刷新列表
            } else {
              this.$message.error(response.data.message || '冻结失败')
            }
          })
          .catch(error => {
            const errorMsg = error.response && error.response.data && error.response.data.message
              ? error.response.data.message
              : '网络错误，请稍后重试'
            this.$message.error(errorMsg)
            console.error('冻结用钱包失败:', error)
          })
      }).catch(() => {
        // 取消删除
      })
    },

    handleUnFreeWallet(row) {
      this.$confirm(`确认解除冻结用户 ${row.username} 的钱包?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 发送删除请求
        axios.delete(`/balance/unfree/wallet/${row.id}`)
          .then(response => {
            if (response.data.status === 200) {
              this.$message.success('解除冻结成功')
              this.fetchUserList() // 刷新列表
            } else {
              this.$message.error(response.data.message || '解除冻结失败')
            }
          })
          .catch(error => {
            const errorMsg = error.response && error.response.data && error.response.data.message
              ? error.response.data.message
              : '网络错误，请稍后重试'
            this.$message.error(errorMsg)
            console.error('冻结用钱包失败:', error)
          })
      }).catch(() => {
        // 取消删除
      })
    },

    // 处理重置登录密码
    handleResetLoginPwd(row) {
      this.resetPwdForm.userId = row.id
      this.resetPwdForm.username = row.username
      this.resetPwdForm.password = ''
      this.resetPwdForm.confirmPassword = ''
      this.resetLoginPwdDialogVisible = true
      
      // 在下一个事件循环中重置表单验证
      this.$nextTick(() => {
        if (this.$refs.resetLoginPwdForm) {
          this.$refs.resetLoginPwdForm.clearValidate()
        }
      })
    },

    // 提交重置登录密码
    submitResetLoginPwd() {
      this.$refs.resetLoginPwdForm.validate(valid => {
        if (valid) {
          this.resetPwdLoading = true
          
          // 构建请求数据
          const data = {
            id: this.resetPwdForm.userId,
            password: this.resetPwdForm.password
          }
          
          // 发送重置请求
          axios.put('/user/password/reset', data)
            .then(response => {
              this.resetPwdLoading = false
              
              if (response.data.status === 200) {
                this.$message.success('登录密码重置成功')
                this.resetLoginPwdDialogVisible = false
              } else {
                this.$message.error(response.data.message || '重置失败')
              }
            })
            .catch(error => {
              this.resetPwdLoading = false
              const errorMsg = error.response && error.response.data && error.response.data.message
                ? error.response.data.message
                : '网络错误，请稍后重试'
              this.$message.error(errorMsg)
              console.error('重置登录密码失败:', error)
            })
        }
      })
    },

    // 处理重置支付密码
    handleResetPayPwd(row) {
      this.resetPwdForm.userId = row.id
      this.resetPwdForm.username = row.username
      this.resetPwdForm.password = ''
      this.resetPwdForm.confirmPassword = ''
      this.resetPayPwdDialogVisible = true
      
      // 在下一个事件循环中重置表单验证
      this.$nextTick(() => {
        if (this.$refs.resetPayPwdForm) {
          this.$refs.resetPayPwdForm.clearValidate()
        }
      })
    },

    // 提交重置支付密码
    submitResetPayPwd() {
      this.$refs.resetPayPwdForm.validate(valid => {
        if (valid) {
          this.resetPwdLoading = true
          
          // 构建请求数据
          const data = {
            id: this.resetPwdForm.userId,
            password: this.resetPwdForm.password
          }
          
          // 发送重置请求
          axios.put('/user/payPassword/reset', data)
            .then(response => {
              this.resetPwdLoading = false
              
              if (response.data.status === 200) {
                this.$message.success('支付密码重置成功')
                this.resetPayPwdDialogVisible = false
              } else {
                this.$message.error(response.data.message || '重置失败')
              }
            })
            .catch(error => {
              this.resetPwdLoading = false
              const errorMsg = error.response && error.response.data && error.response.data.message
                ? error.response.data.message
                : '网络错误，请稍后重试'
              this.$message.error(errorMsg)
              console.error('重置支付密码失败:', error)
            })
        }
      })
    },

    // 处理查看资金往来
    handleViewTransactions(row) {
      this.currentUser = row
      // 设置默认时间范围为一周内
      const endDate = new Date()
      const startDate = new Date()
      startDate.setDate(startDate.getDate() - 7)
      this.transactionDateRange = [
        startDate.toISOString().split('T')[0],
        endDate.toISOString().split('T')[0]
      ]
      this.activeTransactionTab = 'pledgeOrders'
      this.transactionsDialogVisible = true
      this.fetchTransactions(row.id)
    },

    // 获取资金往来记录
    fetchTransactions(userId) {
      this.transactionsLoading = true
      
      let params = {}
      if (this.transactionDateRange && this.transactionDateRange.length === 2) {
        // 使用ISO 8601格式 (yyyy-MM-dd'T'HH:mm:ss)
        params.startTime = this.transactionDateRange[0] + 'T00:00:00'
        params.endTime = this.transactionDateRange[1] + 'T23:59:59'
      }
      
      axios.get(`/balance/exchanges/${userId}`, { params })
        .then(response => {
          this.transactionsLoading = false
          
          if (response.data.status === 200) {
            const { data } = response.data
            this.transactions = {
              pledgeOrders: data.pledgeOrders || [],
              collections: data.collections || [],
              payments: data.payments || [],
              withdraws: data.withdraws || [],
              recharges: data.recharges || []
            }
          } else {
            this.$message.error(response.data.message || '获取资金往来记录失败')
          }
        })
        .catch(error => {
          this.transactionsLoading = false
          const errorMsg = error.response && error.response.data && error.response.data.message
            ? error.response.data.message
            : '网络错误，请稍后重试'
          this.$message.error(errorMsg)
          console.error('获取资金往来记录失败:', error)
        })
    },

    // 处理日期范围变化
    handleDateRangeChange() {
      this.fetchTransactions(this.currentUser.id)
    },

    // 获取质押状态类型
    getPledgeStatusType(status) {
      switch (status) {
        case 0:
          return 'primary' // 进行中
        case 1:
          return 'success' // 已完成
        case 2:
          return 'danger' // 已取消
        default:
          return 'info'
      }
    },

    // 获取质押状态文本
    getPledgeStatusText(status) {
      switch (status) {
        case 0:
          return '进行中'
        case 1:
          return '已完成'
        case 2:
          return '已取消'
        default:
          return '未知'
      }
    },

    // 获取提现状态类型
    getWithdrawStatusType(status) {
      switch (status) {
        case 0:
          return 'warning' // 待处理
        case 1:
          return 'success' // 已完成
        case 2:
          return 'danger' // 已拒绝
        default:
          return 'info'
      }
    },

    // 获取提现状态文本
    getWithdrawStatusText(status) {
      switch (status) {
        case 0:
          return '待处理'
        case 1:
          return '已完成'
        case 2:
          return '已拒绝'
        default:
          return '未知'
      }
    },

    // 获取充值状态类型
    getRechargeStatusType(status) {
      switch (status) {
        case 0:
          return 'warning' // 处理中
        case 1:
          return 'success' // 已完成
        case 2:
          return 'danger' // 已失败
        default:
          return 'info'
      }
    },

    // 获取充值状态文本
    getRechargeStatusText(status) {
      switch (status) {
        case 0:
          return '处理中'
        case 1:
          return '已完成'
        case 2:
          return '已失败'
        default:
          return '未知'
      }
    },

    // 获取VIP等级列表
    fetchVipLevels() {
      axios.get('/vip/list')
        .then(response => {
          if (response.data.status === 200) {
            this.vipLevels = response.data.data || []
          } else {
            this.$message.error(response.data.message || '获取VIP等级列表失败')
          }
        })
        .catch(error => {
          const errorMsg = error.response && error.response.data && error.response.data.message
            ? error.response.data.message
            : '网络错误，请稍后重试'
          this.$message.error(errorMsg)
          console.error('获取VIP等级列表失败:', error)
        })
    },

    // 处理设置VIP等级
    handleSetVip(row) {
      this.vipForm.userId = row.id
      this.vipForm.username = row.username
      this.vipForm.currentVipLevel = row.vipLevel
      this.vipForm.vipId = '' // 重置选择
      this.setVipDialogVisible = true
      
      // 如果还没有获取VIP等级列表，则获取
      if (this.vipLevels.length === 0) {
        this.fetchVipLevels()
      }
      
      // 在下一个事件循环中重置表单验证
      this.$nextTick(() => {
        if (this.$refs.vipForm) {
          this.$refs.vipForm.clearValidate()
        }
      })
    },

    // 提交设置VIP等级
    submitSetVip() {
      this.$refs.vipForm.validate(valid => {
        if (valid) {
          this.setVipLoading = true
          
          // 构建请求数据
          const data = {
            userId: this.vipForm.userId,
            vipId: this.vipForm.vipId
          }
          
          // 发送设置VIP等级请求
          axios.post('/balance/setVip', data)
            .then(response => {
              this.setVipLoading = false
              
              if (response.data.status === 200) {
                this.$message.success('设置VIP等级成功')
                this.setVipDialogVisible = false
                this.fetchUserList() // 刷新列表
              } else {
                this.$message.error(response.data.message || '设置VIP等级失败')
              }
            })
            .catch(error => {
              this.setVipLoading = false
              const errorMsg = error.response && error.response.data && error.response.data.message
                ? error.response.data.message
                : '网络错误，请稍后重试'
              this.$message.error(errorMsg)
              console.error('设置VIP等级失败:', error)
            })
        }
      })
    },

    // 处理转账
    handleTransfer(row) {
      this.transferForm.fromUsername = row.username
      this.transferForm.fromUserInfo = {
        id: row.id,
        username: row.username,
        name: row.name,
        balance: row.balance
      }
      this.transferForm.toUsername = ''
      this.transferForm.toUserInfo = null
      this.transferForm.amount = 100
      this.transferDialogVisible = true
      
      // 在下一个事件循环中重置表单验证
      this.$nextTick(() => {
        if (this.$refs.transferForm) {
          this.$refs.transferForm.clearValidate()
        }
      })
    },
    
    // 处理转账方用户名输入
    handleFromUserBlur() {
      if (!this.transferForm.fromUsername) {
        this.transferForm.fromUserInfo = null
        return
      }
      
      axios.get('/user/userInfo', {
        params: {
          username: this.transferForm.fromUsername
        }
      })
        .then(response => {
          if (response.data.status === 200) {
            this.transferForm.fromUserInfo = response.data.data
          } else {
            this.$message.error(response.data.message || '获取用户信息失败')
            this.transferForm.fromUserInfo = null
          }
        })
        .catch(error => {
          console.error('获取用户信息失败:', error)
          this.$message.error('获取用户信息失败')
          this.transferForm.fromUserInfo = null
        })
    },
    
    // 处理收款方用户名输入
    handleToUserBlur() {
      if (!this.transferForm.toUsername) {
        this.transferForm.toUserInfo = null
        return
      }
      
      axios.get('/user/userInfo', {
        params: {
          username: this.transferForm.toUsername
        }
      })
        .then(response => {
          if (response.data.status === 200) {
            this.transferForm.toUserInfo = response.data.data
          } else {
            this.$message.error(response.data.message || '获取用户信息失败')
            this.transferForm.toUserInfo = 
            {
              username:this.transferForm.toUsername,
              name: '虚拟账号',
              balance: 0
            }
          }
        })
        .catch(error => {
          console.error('获取用户信息失败:', error)
          this.$message.error('获取用户信息失败')
          this.transferForm.toUserInfo = {
            username:this.transferForm.toUsername,
            name: '虚拟账号',
            balance: 0
            }
        })
    },
    
    // 提交转账
    submitTransfer() {
      this.$refs.transferForm.validate(valid => {
        if (valid) {
          if (!this.transferForm.fromUserInfo) {
            this.$message.error('请先查询转账方信息')
            return
          }
          if (!this.transferForm.toUserInfo) {
            this.$message.error('请先查询收款方信息')
            return
          }
          
          this.transferLoading = true
          
          // 构建请求数据
          const data = {
            fromUserId: this.transferForm.fromUserInfo.id,
            toUserId: this.transferForm.toUserInfo.id,
            toUserName: this.transferForm.toUsername,
            amount: this.transferForm.amount
          }
          
          // 发送转账请求
          axios.post('/balance/transfer/supper', data)
            .then(response => {
              this.transferLoading = false
              
              if (response.data.status === 200) {
                this.$message.success('转账成功')
                this.transferDialogVisible = false
                this.fetchUserList() // 刷新列表
              } else {
                this.$message.error(response.data.message || '转账失败')
              }
            })
            .catch(error => {
              this.transferLoading = false
              const errorMsg = error.response && error.response.data && error.response.data.message
                ? error.response.data.message
                : '网络错误，请稍后重试'
              this.$message.error(errorMsg)
              console.error('转账失败:', error)
            })
        }
      })
    },

    // 检查是否为移动端
    checkMobile() {
      this.isMobile = window.innerWidth <= 768
    }
  },
  created() {
    this.checkMobile()
    window.addEventListener('resize', this.checkMobile)
    this.fetchUserList()
    this.fetchVipLevels() // 页面创建时获取VIP等级列表
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkMobile)
  }
}
</script>

<style scoped>
.users-container {
  padding: 20px;
}

.header-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.search-form {
  margin-bottom: 20px;
}

/* 移动端卡片样式 */
.mobile-cards {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.mobile-card {
  margin-bottom: 10px;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.username {
  font-size: 16px;
  font-weight: bold;
}

.card-content {
  margin: 15px 0;
}

.info-item {
  margin-bottom: 8px;
  font-size: 14px;
}

.label {
  color: #909399;
  margin-right: 5px;
}

.card-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 15px;
}

/* 响应式布局 */
@media screen and (max-width: 768px) {
  .users-container {
    padding: 10px;
  }
  
  .search-form {
    display: flex;
    flex-direction: column;
  }
  
  .search-form .el-form-item {
    margin-right: 0;
    margin-bottom: 10px;
  }
  
  .pagination-container {
    margin-top: 15px;
  }
  
  .el-pagination {
    text-align: center;
  }
  
  .card-footer {
    flex-direction: column;
    gap: 10px;
  }
  
  .card-footer .el-button-group {
    display: flex;
    flex-wrap: wrap;
    gap: 5px;
  }
  
  .card-footer .el-button-group .el-button {
    margin-right: 0;
  }
}

.pagination-container {
  margin-top: 20px;
  text-align: right;
}

.balance-cell {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.dialog-footer {
  text-align: right;
}

.transactions-container {
  width: 100%;
}

.transactions-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.user-info {
  margin-top: 10px;
  padding: 10px;
  background-color: #f5f7fa;
  border-radius: 4px;
}
.user-info p {
  margin: 5px 0;
  color: #606266;
}
</style> 